import type { SearchParamsObject } from '@algolia/client-search';

import { searchAlgoliaOptionsFiltersForFacets } from 'modules/search/algolia/options/searchAlgoliaOptionsFiltersForFacets';
import { searchFacetsVolop } from 'modules/search/constants/searchFacetsVolop';
import type { SearchFiltersById } from 'modules/search/types/SearchFiltersById';
import type { SearchLocation } from 'modules/search/types/SearchLocation';
import { algoliaQueryStringFilter } from 'utils/algolia/helpers/algoliaQueryStringFilter';
import { SEARCH_PAGE_SIZE } from 'utils/constants/general/searchPageSize';

const attributesToRetrieve = ['*'];

type Args = {
  filtersById: SearchFiltersById;
  searchLocation: SearchLocation | undefined;
};

export function searchAlgoliaVolopsOptions({
  filtersById,
  searchLocation,
}: Args): SearchParamsObject {
  return {
    facets: ['*'],
    hitsPerPage: SEARCH_PAGE_SIZE,
    attributesToSnippet: ['description:20'],
    attributesToRetrieve,
    filters: [
      `NOT ${algoliaQueryStringFilter('actionType', 'EVENT')}`,
      ...searchAlgoliaOptionsFiltersForFacets({
        filtersById,
        searchFacets: searchFacetsVolop,
        searchLocation,
      }),
    ].join(' AND '),
    removeStopWords: true,
    ignorePlurals: true,
    advancedSyntax: true,
    queryLanguages: ['en', 'es', 'pt'],
  } satisfies SearchParamsObject;
}
